import { render, staticRenderFns } from "./CourseEvaluationDialog.vue?vue&type=template&id=77f2b0f6&scoped=true&"
import script from "./CourseEvaluationDialog.vue?vue&type=script&lang=js&"
export * from "./CourseEvaluationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseEvaluationDialog.vue?vue&type=style&index=0&id=77f2b0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f2b0f6",
  null
  
)

export default component.exports